// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

function scrollBan() {
  const html = $("html")[0];
  // スクロール禁止
  if (html.classList.contains("is-hidden")) {
    html.classList.remove("is-hidden");
    html.style.top = "";
    html.style.removeProperty("--scrollbar-compensation");
    window.scrollTo(0, scrollTop);
    $("html").css({ "scroll-behavior": "smooth" });
  } else {
    scrollTop = window.scrollY;
    const scrollbarWidth = getScrollbarWidth();
    html.style.top = scrollTop * -1 + "px";
    if (scrollbarWidth > 0) {
      html.style.setProperty(
        "--scrollbar-compensation",
        scrollbarWidth + "px"
      );
    }
    html.classList.add("is-hidden");
    $("html").css({ "scroll-behavior": "inherit" });
  }
}
